import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "io-mfe-ig-procedure-header-property flex" }
const _hoisted_2 = { class: "io-mfe-ig-procedure-header-property-label" }
const _hoisted_3 = { class: "io-mfe-ig-procedure-header-property-code" }
const _hoisted_4 = { class: "io-mfe-ig-procedure-header-property-description" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "io-mfe-ig-procedure-header-property-comment" }, null, -1)

import { ProcedureColumnItem } from 'stores/search-store';

interface Props {
  label: string,
  item?: ProcedureColumnItem
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ProcedureHeaderProperty',
  props: {
    label: {},
    item: {}
  },
  setup(__props: any) {


const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(props.label) + ":", 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(props.item?.char), 1),
    _createElementVNode("div", _hoisted_4, _toDisplayString(props.item?.label), 1),
    _hoisted_5
  ]))
}
}

})